interface ISiteFilterArray 
    extends ISiteFilter{
    
    getValues(): string[];
    setValues(value: string[]): void;
    addValue(value: string): void;
    removeValue(value: string): void;
    removeValues(): void;
}
type SiteElementFilterArrayTypes = 'color' | 'checkbox';

class SiteElementFilterArray
    extends SiteElementFilter
    implements ISiteFilterArray {
    
    private _values: string[];
    private _renderer?: ISiteElementFilterRendererQueryElement;
    private _amount?: number;

    constructor(element: HTMLElement, site: SiteAssortment) {
        super(element, site);

        var amount = parseInt(this.getAttr("data-amount") ?? "") || undefined;

        this._values = [];
        this._renderer = undefined;
        this._amount = amount;
    }

    getValues(): string[] {
        return this._values;
    }
    setValues(value: string[]) {
        this._values = value;
    }
    hasValue(): boolean {
        return this._values.length != 0;
    }
    containsValue(value: string): boolean {
        return this._values.indexOf(value) !== -1;
    }
    addValue(value: string): void {
        this._values.push(value);
    }
    removeValue(value: string): void {
        this._values.remove(value);
    }
    removeValues(): void {
        this._values = [];
    }
    updateFilterModel(updateAll: boolean): void {
        this.getSite().updateFilterModel(this,
            updateAll ? [] : [this.getName()]
        );
    }


    setContent(value: ISiteFilterItem): void {
        // -- Create new renderer
        let renderer: ISiteElementFilterRendererQueryElement;

        let state: any;
        if (this._renderer != null)
            state = this._renderer.getState();

        var type = (this.getAttr("data-type") ?? "checkbox") as SiteElementFilterArrayTypes;
        
        switch(this.getAttr("data-renderer"))
        {
            default:
            case "Default":
                renderer = new SiteElementFilterArrayDefaultRenderer(this, value, type, this._amount, state || SiteElementFilterArrayDefaultRenderer.getDefaultState());
                break;
            case "Inline":
                renderer = new SiteElementFilterArrayInlineRenderer(this, value, type);
                break;
            case "Dropdown":
                renderer = new SiteElementFilterArrayDropdownRenderer(this, value, type);
                break;
        }

        if (this._renderer != renderer) {
            // -- Remove old renderer
            if (this._renderer != null)
                this._renderer.remove();
            
            // -- Append new renderer
            this.append(renderer);

            // Add renderer reference:
            this._renderer = renderer;
        }
    }
}